module.exports = __webpack_public_path__ + "img/sketch-about-us-mobile.32972049.svg";